import Axios, { AxiosHeaders, AxiosRequestHeaders, isAxiosError } from 'axios'

import {
  RestApiResponse,
  RestApiTransformer,
  RestRequest,
} from '../helpers/RestHelpers'

class RestApiClient {
  static async call<Request extends RestRequest>(
    request: Request,
    headers?: AxiosHeaders
  ): Promise<RestApiResponse<Request>> {
    let result: RestApiResponse
    const { transformer, ...config } = request

    try {
      result = await Axios({
        ...config,
        headers: {
          ...config?.headers,
          ...headers,
        },
      })
    } catch (e) {
      if (isAxiosError(e)) {
        const status = e.response?.status
        const url = e.config?.url
        console.warn(
          `[RestApi] ${e.config?.method?.toUpperCase() ?? 'REQ'} ${url} -> ${
            status ?? 'network error'
          }`
        )
        if (e.response) {
          const responseData = e.response.data as
            | { error?: unknown; errors?: unknown }
            | undefined

          return {
            ...e.response,
            data: undefined,
            errors:
              responseData?.errors ?? responseData?.error ?? responseData ?? e,
          } as RestApiResponse<Request>
        }
      } else {
        console.warn(`[RestApi] unexpected error:`, e)
      }

      return {
        data: undefined,
        errors: (e as Error)?.message ?? 'error',
        status: 500,
        statusText: (e as Error)?.message ?? 'error',
        headers: {
          ...config?.headers,
          ...headers,
        },
        config: {
          ...config,
          headers: config.headers as AxiosRequestHeaders,
        },
      }
    }

    const data = await RestApiClient.transform(result.data, transformer)

    return { ...result, data }
  }

  static async transform(
    data: RestApiResponse['data'],
    transformer: RestApiTransformer<Transformer>
  ) {
    if (!data || !transformer) {
      return data
    }

    return await transformer(data)
  }
}

export default RestApiClient
